import './Home.css';
import reactLogo from '../../assets/React-icon.svg.png'
import dockerLogo from '../../assets/docker-icon.png'
import fastapiIcon from '../../assets/fastapi-logo.png'
import azureLogo from '../../assets/azure.png'
import chakraLogo from '../../assets/chakra-logo.png'
import moeda from '../../assets/moeda.png'
import { Link } from 'react-router-dom';

export default () => {
    return (
        <div className="home-main">
            <Link to="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/83677228757845385500057673893995298525159805794082348373912945653360623616001/ "><button><img id='moeda-nft' src={moeda} alt="Imagem de uma moeda" /></button></Link>
            <div className='top-info'>
                <h1>This is not magic, this is <span className='datawhize'>&#x044;&#x039B;T&#x039B;WIZ&#x039E;</span></h1>
            </div>

            <div className='container-home'>
                <div className='mid-info'>
                    <h2>About</h2>
                    <p>A versatile solution for any project manager. Are you tired of the mess and lack of order in your <span>projects</span>? With Datawise we take care that your projects are created in the best possible standard, also that your data is sent in the safest way possible! </p>
                </div>

                <div className='technologies-used'>
                    <h2>Technologies used</h2>

                    <ul className='icons-list'>
                        <li><img id="react" className='img-technologies' src={reactLogo} alt="React logo" /></li>
                        <li><img className='img-technologies' src={dockerLogo} alt="Docker logo" /></li>
                        <li><img id="fastapi" className='img-technologies' src={fastapiIcon} alt="Fastapi logo" /></li>
                        <li><img id="azure" className='img-technologies' src={azureLogo} alt="Google Cloud logo" /></li>
                        <li><img className='img-technologies' src={chakraLogo} alt="Chakra logo" /></li>
                    </ul>

                    <p>Have you ever thought about what could happen if one day your application needed to receive more data than it supports today? Well, we did it for you! We use technologies that allow our product to scale infinitely, in a safe and controlled way. The main ones are <span>Docker</span> and <span>Azure</span>.</p>
                </div>

                <div className='scalability'>
                    <h2>Scalability</h2>
                    <p>Docker is a super versatile tool that allows you to infinitely scale applications, systems and services. It is a modern and safe technology.<br />
                        Docker is an open source platform that allows you to build, deploy and run containerized applications. It provides an efficient way to package
                        an application along with its dependencies in an isolated image. Key features of Docker include:

                        <ul className='docker-list'>
                            <br />
                            <li><i>Containers:</i> Docker uses containers to isolate applications and their dependencies, ensuring they run consistently in any environment.</li>
                            <li><i>Portability:</i> Docker images are platform agnostic, meaning they can run on any operating system that has Docker installed.</li>
                            <li><i>Scalability:</i> Docker makes it easy to deploy and scale applications, allowing you to run multiple containers on a single host or distribute them across multiple hosts.</li>
                            <li><i>Resource management:</i> Docker provides advanced resource management capabilities, allowing you to control the amount of CPU, memory, and other resources used by each container.</li>
                        </ul></p>
                </div>
            </div>


        </div>

    )
}
